import { useWriteIndicator } from '../useWriteIndicator/useWriteIndicator';
import { Backdrop } from '../Backdrop/Backdrop';
import { CornerSpinner } from './CornerSpinner/CornerSpinner';
import { useDelayedVisibility } from '../useDelayedVisibility/useDelayedVisibility';

/**
 * The one indicator shown while any write is in flight, mounted once per app.
 * Per-page backdrops would need every page to combine its `isPending` flags,
 * and a forgotten one lets a customer tap twice.
 *
 * A backdrop write blocks the screen; a corner write (an autosave) spins in
 * the top right and blocks nothing. `useWriteIndicator` picks which.
 *
 * The delay keeps a fast mutation from flashing either one.
 *
 * A mutation is in flight until its onSuccess invalidation settles, so the
 * screen stays blocked until the data is fresh.
 */
export const GlobalMutatingBackdrop = () => {
  const writeIndicator = useWriteIndicator();
  const isBackdropVisible = useDelayedVisibility({
    isActive: writeIndicator === 'backdrop',
  });
  const isCornerVisible = useDelayedVisibility({
    isActive: writeIndicator === 'corner',
  });

  return (
    <>
      <Backdrop open={isBackdropVisible} />
      <CornerSpinner open={isCornerVisible && !isBackdropVisible} />
    </>
  );
};
